import { withTokensIfNeeded } from 'common/api/utils/withTokensIfNeeded';
import { FULFILLMENT_SHIPPING_URL } from 'common/api/config';
import { toQueryString } from 'common/utils/queryString';

export interface ShipDateEstimation {
    estimatedShipDate: string;
    estimateIncludesHolidays: boolean;
}

export const getEstimatedShipDate = async (name: string, orderSubtotal: number) => {
    const response = await withTokensIfNeeded<ShipDateEstimation>(
        `${FULFILLMENT_SHIPPING_URL}/ship-date?${toQueryString({ method: name, orderSubtotal })}`
    );
    return response;
};

export const getUspsShippingOrderSubtotalLimit = async () => {
    const response = await withTokensIfNeeded<number>(
        `${FULFILLMENT_SHIPPING_URL}/usps-shipping-order-subtotal-limit`
    );
    return response;
};
